// extracted by mini-css-extract-plugin
export var body = "index-module--body--gJm2T";
export var details_container = "index-module--details_container--3dwZZ";
export var details_wrapper = "index-module--details_wrapper--599-I";
export var heading = "index-module--heading--KCTha";
export var heading_text = "index-module--heading_text--FKuaY";